import { useEffect, useState } from "react";
import { Bell } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("veloclin_token")}` });

export const NotificationsBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const r = await fetch(`${API}/api/clinic/notifications`, { headers: authHeaders() });
      if (r.ok) {
        const d = await r.json();
        setItems(d.notifications || []);
        setUnread(d.unread || 0);
      }
    } catch (e) { /* ignore */ }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, []);

  const toggle = async () => {
    const willOpen = !open;
    setOpen(willOpen);
    if (willOpen && unread > 0) {
      try {
        await fetch(`${API}/api/clinic/notifications/read`, { method: "POST", headers: authHeaders() });
        setUnread(0);
        setItems((p) => p.map((n) => ({ ...n, read: true })));
      } catch (e) { /* ignore */ }
    }
  };

  return (
    <div className="relative">
      <button
        data-testid="notif-bell"
        onClick={toggle}
        className="relative z-50 flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50"
        title="Notificações"
      >
        <Bell className="h-4 w-4" />
        {unread > 0 && (
          <span data-testid="notif-badge" className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div data-testid="notif-panel" className="absolute right-0 z-50 mt-2 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl">
            <div className="border-b border-slate-100 px-4 py-2.5 text-sm font-bold text-slate-800">Notificações</div>
            {items.length === 0 ? (
              <p data-testid="notif-empty" className="px-4 py-6 text-center text-xs text-slate-400">Sem notificações.</p>
            ) : (
              <div className="max-h-80 divide-y divide-slate-50 overflow-y-auto">
                {items.map((n) => (
                  <div key={n.id} data-testid={`notif-item-${n.id}`} className={`px-4 py-2.5 ${n.read ? "" : "bg-blue-50/40"}`}>
                    <p className="text-sm text-slate-700">{n.message}</p>
                    <p className="mt-0.5 text-[11px] text-slate-400">{n.created_at ? new Date(n.created_at).toLocaleString("pt-BR") : ""}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
